<template>
    
    <transition name="fade">
      <router-view></router-view>
    </transition>

</template>
<script>
     
     export default {
        name: 'App',
    }
</script>

<style>

    body, html {background-color: #010431}



* {  -webkit-user-select: none;  /* Chrome all / Safari all */
  -moz-user-select: none;     /* Firefox all */
  -ms-user-select: none;      /* IE 10+ */
  user-select: none;   }

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>